import type { HeadFC, PageProps } from 'gatsby';
import { graphql } from 'gatsby';
import type { FC } from 'react';
import type { BlogDetail } from '../../@types/gql/blog';
import type { SEOEntity } from '../../@types/gql/seo';
import SEOComponent from '../../components/shared/seo';
import ContactUsWidget from '../../components/shared/widget/contact-us';
import DetailsContainer from '../../components/blog/detail/DetailsContainer';
import type { AllStrapiBlog } from '../../@types/gql/sidebar';

export const query = graphql`
  query BlogDetailQuery($slug: String!) {
    strapiBlog(Slug: { eq: $slug }) {
      seo {
        ...SEOFragment
      }
      Title
      ShortDescription
      Content
      category
      publishedAt
      Thumbnail {
        url
      }
      BlogFaq {
        Question
        Answer
        id
      }
    }
    # Sidebar Query
    sidebarBlogs: allStrapiBlog(sort: { publishedAt: DESC }) {
      nodes {
        Title
        Slug
        category
        Thumbnail {
          url
        }
        publishedAt
        seo {
          keywords
        }
      }
    }
  }
`;

const BlogDetailTemplate: FC<
  PageProps<
    { strapiBlog: BlogDetail; sidebarBlogs: AllStrapiBlog },
    { slug: string }
  >
> = ({ data }) => {

  return (
    <>
      <DetailsContainer       
        postDetails={data.strapiBlog}
        sidebar={data.sidebarBlogs.nodes}
      />
      {/* <BlogDetailHeader
        publishedDate={publishedAt}
        shortDescription={ShortDescription}
        slug={pageContext.slug}
        title={Title}
      />
      <Markdown className="rich-text-view prose-ul:list-disc prose-ol:list-decimal container px-6 mx-auto py-14">
        {Content}
      </Markdown> */}
      <ContactUsWidget />
    </>
  );
};

export default BlogDetailTemplate;

export const Head: HeadFC<{ strapiBlog: { seo?: SEOEntity, BlogFaq?: { Question: string; Answer: string; id: string }[] } }> = ({ data }) => (
<>
<SEOComponent seo={data.strapiBlog.seo} />
  {data.strapiBlog.BlogFaq && data.strapiBlog.BlogFaq.length > 0 ? <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: data.strapiBlog.BlogFaq.map((faq) => ({
          "@type": "Question",
          name: faq.Question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.Answer,
          },
        })),
      })}
    </script> : null}
</>
);
